/* eslint-disable jsx-a11y/label-has-associated-control */
import { Form, Input, Modal } from 'antd';
import { useChangeHandler } from 'hooks';
import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import { sitesCleanUp } from 'state/actions/sites';
import { regexDescription, regexInput } from 'utils/regex';
import { log } from 'utils';

const ModalOrganizationForm = ({
  visible,
  onCancel,
  onCreate,
  organization,
  setOrganization,
  isEditing,
}) => {
  const dispatch = useDispatch();
  const [form] = Form.useForm();

  const { loading } = useSelector(
    (state) => ({
      loading: state.organizations.loading,
    }),
    shallowEqual
  );

  const [errors, setErrors] = useState({
    name: '',
    description: '',
  });

  useEffect(() => {
    return () => dispatch(sitesCleanUp());
  }, [dispatch]);

  const onSave = (values) => {
    if (regexInput(values.name) && regexDescription(values.description)) {
      onCreate({
        ...organization,
        name: values.name,
        description: values.description,
      });
      form.resetFields();
    } else {
      setErrors({
        ...errors,
        name:
          !regexInput(values.name) &&
          'This field cannot contain a special characters',
        description:
          !regexDescription(values.description) &&
          'This field cannot contain a special characters',
      });
    }
  };

  const onChangeHandler = useChangeHandler(setOrganization);

  return (
    <Modal
      visible={visible}
      title={isEditing ? 'Edit Organization' : 'Create New Organization'}
      okText="Submit"
      confirmLoading={loading}
      onCancel={() => {
        onCancel();
        form.resetFields();
      }}
      onOk={() => {
        form
          .validateFields()
          .then((values) => {
            onSave(values);
          })
          .catch((info) => {
            log('Validate Failed:', info);
          });
      }}
    >
      <Form
        layout="vertical"
        form={form}
        onChange={onChangeHandler}
        initialValues={{
          name: organization.name,
          description: organization.description,
        }}
      >
        <Form.Item
          label="Name"
          name="name"
          rules={[{ required: true }]}
          validateStatus={errors.name ? 'error' : 'success'}
          help={errors.name ? errors.name : null}
        >
          <Input />
        </Form.Item>
        <Form.Item
          label="Description"
          name="description"
          rules={[{ required: true }]}
          validateStatus={errors.description ? 'error' : 'success'}
          help={errors.description ? errors.description : null}
        >
          <Input.TextArea rows={4} placeholder="Description" />
        </Form.Item>
      </Form>
    </Modal>
  );
};

ModalOrganizationForm.propTypes = {
  userData: PropTypes.shape({
    id: PropTypes.string,
    name: PropTypes.string.isRequired,
  }),
};

export default ModalOrganizationForm;
